var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurity({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-lock-5019560",
    d: "M175.8,56.176a7.457,7.457,0,0,0-7.495,7.43v4.57h-1.55a2.875,2.875,0,0,0-2.879,2.861V83.243a2.875,2.875,0,0,0,2.879,2.861H185a2.875,2.875,0,0,0,2.879-2.861V71.037A2.875,2.875,0,0,0,185,68.176h-1.7v-4.57a7.457,7.457,0,0,0-7.495-7.43Zm0,1.032a6.405,6.405,0,0,1,6.463,6.4v4.57H169.337v-4.57a6.405,6.405,0,0,1,6.463-6.4Zm-9.045,12H185a1.822,1.822,0,0,1,1.847,1.828V83.243A1.822,1.822,0,0,1,185,85.07H166.755a1.822,1.822,0,0,1-1.847-1.828V71.037a1.822,1.822,0,0,1,1.847-1.828Zm9.121,3.972a2.756,2.756,0,0,0-.514,5.467v1.933a.516.516,0,0,0,1.032,0V78.647a2.755,2.755,0,0,0-.518-5.466Zm-.045,1.032h.045a1.722,1.722,0,1,1-.045,0Z",
    transform: "translate(-163.876 -56.176)",
    fill: "#1d1d1f",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.8cebdcc7ad33f77750a6cbd0facfc19c.svg";
export { ForwardRef as ReactComponent };